/* eslint-disable react/prop-types, @typescript-eslint/explicit-function-return-type */
import React from "react";
import { Provider } from "react-redux";
import globalStore from "web/redux/store";
/**
 * It's React-Redux's <Provider> component but it defaults to our store
 */

export var ReduxWrapper = function ReduxWrapper(_ref) {
  var children = _ref.children,
      _ref$store = _ref.store,
      store = _ref$store === void 0 ? globalStore : _ref$store;
  return React.createElement(Provider, {
    store: store,
    children: children
  });
};
/**
 * Mainly designed for renderHook - wraps ReduxWrapper with a predefined store
 * (eg the one you made for the test)
 * @param store The store you want to use instead of the global one
 */

export function reduxTestWrapper(store) {
  /* eslint-disable react/display-name */
  return function (_ref2) {
    var children = _ref2.children;
    return React.createElement(ReduxWrapper, {
      store: store,
      children: children
    });
  };
}
/**
 * HOC for connecting components to the Redux store.
 * In general, you should only use this on the root element rendered by
 *  Hypernova and not anything higher up the tree.
 * @param WrappedComponent The component to wrap
 * @param store Lets you override which store the component is connected to.
 */

export function withRedux(WrappedComponent, store) {
  return function withRedux(props) {
    return React.createElement(ReduxWrapper, {
      store: store
    }, React.createElement(WrappedComponent, props));
  };
}
export default withRedux;